import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Modal, ModalBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { deleteAccount } from 'Redux/ducks/auth';
import store from 'Redux/store';

import 'Components/Account/LoginAndSecurity/AccountDelete.scss';

export default function AccountDelete({ auth, userCanDeleteAccount }) {
  const [modal, setModal] = useState(false);
  const [input, setInput] = useState('');
  const [emailConfirmed, setEmailConfirmed] = useState(false);

  useEffect(() => {
    if (auth.email === input) {
      setEmailConfirmed(true);
    } else {
      setEmailConfirmed(false);
    }
  }, [input, auth.email]);

  const toggle = () => {
    setModal(!modal);
  };

  const submitDelete = (e) => {
    if (e) e.preventDefault();
    store.dispatch(deleteAccount());
  };

  return (
    <div>
      <div className="account-table-row">
        <div className="account-table-row-title">
          <FormattedMessage id="account-login-security.account-delete.title" defaultMessage="Delete Account" />
        </div>
        <div className="account-table-row-content">
          <div className="account-table-details-smallprint">
            <FormattedMessage id="account-login-security.account-delete.desc" defaultMessage="Deleting account is irreversible and cannot be undone. You will be logged out upon deletion of account." />
          </div>
          <div className="account-table-action-container">
            {userCanDeleteAccount &&
              <button className="account-table-action-button" onClick={() => toggle()}>
                <FormattedMessage id="account-delete-btn" defaultMessage="Delete Account" />
              </button>
            }
            {!userCanDeleteAccount &&
              <button className="account-table-action-button disabled">
                <FormattedMessage id="account-delete-btn.cant" defaultMessage="Please contact support to delete your account" />
              </button>
            }
          </div>
        </div>
      </div>

      <Modal isOpen={modal} toggle={toggle} className="account-modal">
        <ModalBody>
          <div className="account-modal-title">
            <FormattedMessage id="account-delete.modal.title" defaultMessage="Confirm Account Deletion" />
          </div>

          <div className="account-modal-form">
            <p className="account-modal-paragraph">
              <FormattedMessage
                id="account-delete-btn-confirm"
                defaultMessage="You are about to delete your account, this action is {permanent}. You will be logged out upon successful deletion."
                values={{
                  permanent: <strong><FormattedMessage id="account-delete-btn-confirm.permanent" defaultMessage="PERMANENT" /></strong>,
                }}
              />
            </p>
            <p className="account-modal-paragraph">
              <FormattedMessage id="account-delete-btn-confirm-1" defaultMessage="Please type:" />
              <code> {auth.email} </code>
              <FormattedMessage id="account-delete-btn-confirm-2" defaultMessage="if you wish to continue" />
            </p>

            <div className="form-group mb-0">
              <div className="account-modal-form-input">
                <input
                  type="email"
                  inputMode="email"
                  autoComplete="off"
                  className="form-control"
                  aria-label="email-confirm-input"
                  aria-describedby="email-confirm-input"
                  onChange={event => setInput(event.target.value)}
                />
                {!emailConfirmed && input.length > 0 &&
                  <div className="invalid-field">
                    Please enter your email address
                  </div>
                }
              </div>

              <div className="account-modal-form-buttons">
                <div className="form-button-container full-width mb-0">
                  <Button color="error" disabled={!emailConfirmed} onClick={e => submitDelete(e)}>
                    <FormattedMessage id="account-delete.form.delete" defaultMessage="Delete Account" />
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>

        <div className="close-button-container">
          <button aria-label="close" onClick={() => toggle()}>
            <FontAwesomeIcon icon={faXmark} title="Close modal" />
          </button>
        </div>
      </Modal>
    </div>
  );
}

AccountDelete.propTypes = {
  userCanDeleteAccount: PropTypes.bool,
};

AccountDelete.defaultProps = {
  userCanDeleteAccount: false,
};
